import React, { useEffect, useState } from 'react'
import './Popular.css'
import Item from '../Item/Item'

const Popular = () => {
    // State's
    const [popularProducts, setPopularProducts] = useState([]);
    let API_URL;
    if (process.env.REACT_APP_MODE === "production") {
        API_URL = process.env.REACT_APP_API_URL_PROD;
    } else {
        API_URL = process.env.REACT_APP_API_URL_DEV;
    }

    useEffect(() => {
        fetch(`${API_URL}/popularinwomen`)
            .then((response) => response.json())
            .then((data) => setPopularProducts(data))
    }, [])

    return (
        <div className='popular'>
            <h1>POPULAR IN WOMEN</h1>
            <hr />
            <div className="popular-item">
                {popularProducts.map((item, i) => {
                    return <Item key={i} id={item.id} name={item.name} image={item.image} new_price={item.new_price} old_price={item.old_price} />
                })}
            </div>
        </div>
    )
}

export default Popular